export function ofsaPostSlider() {
	'use strict';

	new Swiper('.post-slider', {
		modules: [],
		slidesPerView: 1.2,
		spaceBetween: 16,
		speed: 500,
		autoplay: {
			delay: 3000,
		},
		breakpoints: {
			640: {
				slidesPerView: 2.2,
			},
			1024: {
				slidesPerView: 3.2,
			},
		},
	});
}
